import { useStore } from '@/composables/store'
import { checkRouteAccessPermissions, checkRouteAccessPermissionsNested } from '@/helpers/acl'

import DefaultLayout from '@/layouts/Default.vue'
import CommissionTurnoverAndRevenueReport from '@/views/reporting/commissions/CommissionTurnoverAndRevenueReport.vue'
import FinmaReportCreate from '@/views/reporting/finmaReport/FinmaReportCreate.vue'

export default [
    // TODO improvement @TFU: Check if "reporting" should be a parent route item (whereof "finma-report" would be a child)
    // TODO improvement @TFU: How should multiple levels of nested children properly be handled? (`accessPermission`, and especially `component`?)
    {
        path: '/reporting',
        name: 'reporting',
        component: DefaultLayout,
        meta: {
            navGroup: 'reporting',
        },
        redirect: () => {
            const store = useStore()
            if (store.state.user.aclFeatures.includes('Feature:commissions:core') && store.state.user.aclPermissions.includes('GlobalReport:CommissionTurnoverAndRevenueReport:read:all')) {
                return { name: 'commissions-reporting' }
            } else {
                return { name: 'finma-report' }
            }
        },
    },
    {
        path: '/reporting/finma-report',
        name: 'finma-report',
        component: DefaultLayout,
        meta: {
            accessPermissions: ['FinmaReport:manage'],
            can: checkRouteAccessPermissionsNested,
            navGroup: 'reporting',
        },
        redirect: { name: 'finma-report-create' },
        children: [
            {
                path: 'create',
                name: 'finma-report-create',
                component: FinmaReportCreate,
                meta: {
                    navGroup: 'reporting',
                },
                props: true,
            },
        ],
    },
    {
        path: '/reporting/commissions',
        name: 'commissions-reporting',
        component: DefaultLayout,
        meta: {
            navGroup: 'reporting',
        },
        redirect: () => {
            const store = useStore()
            return { name: 'commission-turnover-and-income-report', params: { id: store.state.user.tenantCompany.id } };
        },
        children: [
            {
                path: 'commission-turnover-and-income-report/:id(\\d+)',
                name: 'commission-turnover-and-income-report',
                component: CommissionTurnoverAndRevenueReport,
                meta: {
                    accessPermissions: ['GlobalReport:CommissionTurnoverAndRevenueReport:read:all'],
                    can: checkRouteAccessPermissions,
                    navGroup: 'reporting',
                },
                props: true,
            },
        ],
    },
]
